import React, { useEffect } from 'react'
import { InputBase, MenuItem, Select, styled } from '@mui/material'
import { Icon } from '../../eid-icons'
import ArrowIcon from './ArrowIcon'

const CenteredDiv = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
})

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    minWidth: '26rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '0.5rem',
    color: '#919193',
    fontSize: '1.6rem',
    borderRadius: '0.4rem',
    padding: '0.8rem 1.2rem',
    '&:hover': {
        backgroundColor: '#f5f6f8 !important',
    },
}))

const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiSelect-iconOpen': {
        transform: 'rotate(180deg) !important',
    },
}))

const StyledInputBase = styled(InputBase)(({ theme, inputStyles }) => ({
    '& .MuiInputBase-input': {
        display: 'flex',
        alignItems: 'center',
        fontSize: '1.3rem',
        height: '3.4rem',
        padding: '0 1rem',
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:hover': {
            borderColor: `${theme.palette.primary.main} !important`,
        },
        '&:focus': {
            borderColor: theme.palette.primary.main,
            boxShadow: `0 0.2rem 0.4rem 0 ${theme.palette.primary.light}`,
        },
    },
    ...inputStyles,
}))

const StyledArrowIcon = styled(ArrowIcon)({
    position: 'absolute',
    top: '1.5rem',
    right: '1.2rem',
    color: '#919193',
    pointerEvents: 'none',
})

const SelectMenu = ({ options, inputStyles, handleSelect }) => {
    const menuProps = {
        PaperProps: {
            sx: {
                marginTop: '0.4rem',
                padding: '0 0.6rem',
                '& .Mui-selected': {
                    color: '#000000 !important',
                    backgroundColor: '#f5f6f8 !important',
                },
            },
        },
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
        },
        getContentAnchorEl: null,
    }

    const [value, setValue] = React.useState({
        route: '',
    })

    useEffect(() => {
        const value = options.find((i) => i.selected === true)
        if (value) {
            setValue(value)
        }
    }, [options])

    return (
        <StyledSelect
            variant="standard"
            value={value.route}
            renderValue={(value) => (
                <span>{options.find((o) => o.route === value)?.title}</span>
            )}
            input={<StyledInputBase inputStyles={inputStyles} />}
            IconComponent={(props) => (
                <StyledArrowIcon
                    {...props}
                    className={`material-icons ${props.className}`}
                />
            )}
            MenuProps={menuProps}
        >
            {options.map((option) => (
                <StyledMenuItem
                    onClick={() => {
                        setValue(option)
                        handleSelect(option)
                    }}
                    key={option.route}
                    value={option.route}
                    selected={option.selected}
                >
                    <CenteredDiv>
                        <Icon
                            name={option.icon.small}
                            id={`${option.icon.small}-header`}
                            color="#919193"
                        />
                        <span style={{ margin: '0 1.6rem' }}>
                            {option.title}
                        </span>
                    </CenteredDiv>
                    {option.selected && (
                        <CenteredDiv>
                            <Icon
                                name="Check"
                                width="1rem"
                                height="0.7rem"
                                color="#7d7c7c"
                            />
                        </CenteredDiv>
                    )}
                </StyledMenuItem>
            ))}
        </StyledSelect>
    )
}

export default SelectMenu
